import { TableConfig } from 'src/app/shared/components/generic-table';
import { RegistryFavoriteView } from './services/registry-favorite.facade';
import { ThousandsMaskPipe } from 'src/app/shared/pipes/thousands-mask.pipe';

export type RegistryFavoriteColumnKeys = keyof RegistryFavoriteView | '_icon' | '_actions';

export const REGISTRY_FAVORITE_NO_DATA_PERSON_MESSAGE = $localize`:@@noDataFavoritePersonDisplay:No hay datos para mostrar.`;
export const REGISTRY_FAVORITE_NO_DATA_COMPANY_MESSAGE = $localize`:@@noDataFavoriteCompanyDisplay:No hay datos para mostrar.`;

const thousandMask = new ThousandsMaskPipe();

export const getRegistryFavoriteTableConfig = (): TableConfig<
  RegistryFavoriteView,
  RegistryFavoriteColumnKeys
> => ({
  columns: [
    {
      id: '_icon',
      title: $localize`:@@js_type:Tipo`,
      hasCustomContent: true,
      width: '50px',
      minWidth: '50px',
      maxWidth: '50px',
    },
    {
      id: 'name',
      title: $localize`:@@js_name:Nombre`,
      width: '1fr',
      minWidth: '200px',
      getValue: (row: RegistryFavoriteView) => row.name,
    },
    {
      id: 'document',
      title: $localize`:@@js_document:Documento`,
      hasCustomContent: true,
      width: '200px',
      minWidth: '150px',
    },
    {
      id: 'score',
      title: 'Score',
      width: '150px',
      textAlign: 'center',
      getValue: (row: RegistryFavoriteView) =>
        row.score ? thousandMask.transform(row.score) : '-',
    },
    {
      id: '_actions',
      title: $localize`:@@actions:Acciones`,
      hasCustomContent: true,
      width: '200px',
      textAlign: 'center',
    },
  ],
  trackByProp: ['id', 'registryId'],
  rowIdFn: (row: RegistryFavoriteView) => String(row.id)
});

export const registryFavoriteTableConfig = getRegistryFavoriteTableConfig();
